import { SlidersHorizontal } from 'lucide-react';

const BARVA = '#F59E0B';

/**
 * Úprava ingrediencí hned po ťuknutí v pokladně.
 *
 * Normálně ťuknutí položku rovnou přidá a kdo chce něco měnit, ťukne na ni
 * v účtu. U produktů, které se ladí skoro pokaždé (burger, bowl), je to
 * krok navíc — tady se dá zapnout, ať pokladna otevře úpravu sama.
 *
 * Nastavuje se na kategorii a dědí se do podkategorií a produktů, produkt
 * to může přebít. `value` null = podle nadřazené úrovně, `zdedeno` je
 * hodnota, kterou by uzel zdědil.
 */
export default function UpravyPoTuknuti({ value, zdedeno = false, nazevZdedeni = 'Podle kategorie', onChange, isDark }) {
    const muted = isDark ? 'rgba(255,255,255,0.4)' : 'var(--text-muted)';
    const border = isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)';

    const volby = [
        { id: null, nazev: `${nazevZdedeni} (${zdedeno ? 'ano' : 'ne'})` },
        { id: true, nazev: 'Ano' },
        { id: false, nazev: 'Ne' },
    ];

    return (
        <div className="rounded-xl px-4 py-3" style={{
            background: isDark ? 'rgba(255,255,255,0.03)' : 'var(--surface-base)',
            border: `1px solid ${border}`,
        }}>
            <div className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>Upravit hned po ťuknutí</div>
            <p className="text-[11px] mb-2" style={{ color: muted }}>
                Pokladna po ťuknutí do nabídky rovnou otevře úpravu ingrediencí, místo aby položku jen přidala na účet.
            </p>
            <div className="flex flex-wrap gap-1.5">
                {volby.map(v => {
                    const on = (value ?? null) === v.id;
                    return (
                        <button key={String(v.id)} type="button" onClick={() => onChange(v.id)}
                            className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium"
                            style={{
                                background: on ? `${BARVA}26` : 'transparent',
                                border: `1px solid ${on ? BARVA : border}`,
                                color: on ? BARVA : 'var(--text-primary)', cursor: 'pointer',
                            }}>
                            {v.id === null && <SlidersHorizontal size={12} />}
                            {v.nazev}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
